import { SxProps, Theme } from "@mui/material";

export const modalBoxStyles: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "16px",
  boxShadow: 24,
  background: "none",
  width: { xs: "92%", sm: "90%", md: "720px" },
  maxWidth: { xs: "520px", sm: "820px" },
  outline: "none",
};

export const headerStyles: SxProps<Theme> = (theme: Theme) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  background: theme.palette.recordingsModal.headerBg,
  paddingY: "16px",
  paddingX: "38px",
  borderTopLeftRadius: "16px",
  borderTopRightRadius: "16px",
});

export const contentStyles: SxProps<Theme> = (theme: Theme) => ({
  backgroundColor: theme.palette.recordingsModal.background,
  paddingY: "22px",
  paddingX: { xs: "20px", sm: "38px" },
  borderBottomLeftRadius: "16px",
  borderBottomRightRadius: "16px",
  overflow: "auto",
  maxHeight: "70dvh",
});

export const itemsGridStyles = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
  gap: "12px",
  width: "100%",
  alignItems: "stretch",
};

export const fullWidthGridItemStyles = {
  gridColumn: { xs: "1", sm: "1 / -1" },
};

export const loadingGridItemStyles = {
  gridColumn: { xs: "1", sm: "1 / -1" },
  display: "flex",
  justifyContent: "center",
  py: 3,
};

export const errorActionsStyles: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 1.5,
  py: 2,
};

export const retryButtonStyles: SxProps<Theme> = {
  textTransform: "none",
  borderRadius: "999px",
  fontWeight: 600,
  px: 2,
};

export const itemStyles: SxProps<Theme> = (theme: Theme) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "12px",
  padding: "14px 16px",
  display: "flex",
  flexDirection: "column",
  gap: "6px",
  minWidth: 0,
  height: "100%",
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[1],
  transition: "box-shadow 0.16s ease, border-color 0.16s ease",
  cursor: "pointer",
  "&:hover": {
    boxShadow: theme.shadows[2],
    borderColor: theme.palette.primary.main,
  },
});

export const itemTitleStyles: SxProps<Theme> = (theme: Theme) => ({
  fontFamily: "Red Hat Display",
  fontSize: "15px",
  fontWeight: 700,
  color: theme.palette.modalColors.colorLable,
  lineHeight: 1.3,
  flex: 1,
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const itemMetaStyles: SxProps<Theme> = (theme: Theme) => ({
  fontFamily: "Red Hat Display",
  fontSize: "13px",
  fontWeight: 500,
  color: theme.palette.text.secondary,
  lineHeight: 1.35,
});

export const itemHeaderRowStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: 1,
  minWidth: 0,
  overflow: "hidden",
};

export type TeamAssessmentStatus = "live" | "scheduled" | "finished";

export const statusChipStyles = (
  theme: Theme,
  status: TeamAssessmentStatus,
) => {
  const isDark = theme.palette.mode === "dark";

  if (status === "live") {
    return {
      height: 22,
      fontFamily: "Red Hat Display",
      fontSize: "11px",
      fontWeight: 700,
      borderRadius: "999px",
      backgroundColor: isDark
        ? "rgba(74, 222, 128, 0.18)"
        : "rgba(34, 197, 94, 0.16)",
      color: isDark ? "#86EFAC" : "#15803D",
      "& .MuiChip-label": {
        px: 1,
      },
    };
  }

  if (status === "scheduled") {
    return {
      height: 22,
      fontFamily: "Red Hat Display",
      fontSize: "11px",
      fontWeight: 700,
      borderRadius: "999px",
      backgroundColor: isDark
        ? "rgba(56, 189, 248, 0.22)"
        : "rgba(14, 165, 233, 0.16)",
      color: isDark ? "#7DD3FC" : "#0369A1",
      "& .MuiChip-label": {
        px: 1,
      },
    };
  }

  return {
    height: 22,
    fontFamily: "Red Hat Display",
    fontSize: "11px",
    fontWeight: 700,
    borderRadius: "999px",
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.secondary,
    "& .MuiChip-label": {
      px: 1,
    },
  };
};
